import { Pipe, PipeTransform } from '@angular/core';
import { CardModel, JobEquipment } from 'src/app/models';

@Pipe({ name: 'toJobEquipmentCards' })
export class JobEquipmentCardsPipe implements PipeTransform {
  transform(values: JobEquipment[]): CardModel[] {
    return values?.map((e) => CardModel.fromJobEquipmentModel(e) );
  }
}
